import {action, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import SaporeForm from "../../forms/SaporeForm";
import EmailField from "../../forms/fields/EmailField";
import errorToast from "../../components/toast/ErrorToast";

export class RecoverPasswordFeature {
    constructor(application) {
        this._form = this._createForm();
        this._application = application;
        this._passwordRecovered = false;
        this.loading = false;
        makeObservable(this, {
            _form: observable,
            _passwordRecovered: observable,
            loading: observable,
            setLoading: action,
        })
    }

    _createForm() {
        const fields = {
            "email": new EmailField(false),
        }
        return new SaporeForm(fields)
    }

    get form() {
        return this._form;
    }

    set form(value) {
        this._form = value;
    }

    get passwordRecovered() {
        return this._passwordRecovered;
    }

    set passwordRecovered(value) {
        this._passwordRecovered = value;
    }

    emailField() {
        return this.form.getFieldByName("email")
    }

    setLoading(value) {
        this.loading = value;
    }

    async recoverPassword() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: () => {
                this._passwordRecovered = true;
                this.setLoading(false);
            },
            handlesError: () => {
                errorToast("No se ha podido enviar el correo de reestablecimiento de contraseña");
                this.setLoading(false);
            },
        });
        this.setLoading(true);
        await this._application.recoverPassword(this.emailField().value, responseHandler);
    }
}